module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider"
  }, [_c('ext-btn', {
    staticClass: "slider__blog",
    attrs: {
      "size": "normal",
      "color": "transparent",
      "to": _vm.path
    }
  }, [_vm._v("Все события")]), _c('ul', {
    staticClass: "slider__item view",
    style: ({
      width: ((_vm.slides.length * 100) + "%"),
      marginLeft: ("-" + (_vm.curr * 100) + "%")
    })
  }, _vm._l((_vm.slides), function(slide) {
    return _c('li', {
      staticClass: "view__item",
      class: {
        view__item_curr: slide.curr
      },
      style: ({
        backgroundImage: ("url(" + (slide.img) + ")"),
        width: (((100 / _vm.slides.length)) + "%")
      })
    }, [_c('ext-link', {
      staticClass: "view__link",
      attrs: {
        "to": slide.to
      }
    }, [_c('div', {
      staticClass: "view__text"
    }, [_c('div', {
      staticClass: "view__title",
      domProps: {
        "innerHTML": _vm._s(slide.title)
      }
    }), _c('div', {
      staticClass: "view__event_type"
    }, [_vm._v(_vm._s(_vm.getEventType(slide)))]), _c('div', {
      staticClass: "view__note",
      domProps: {
        "innerHTML": _vm._s(slide.note)
      }
    })])])], 1)
  }), 0), _c('ul', {
    staticClass: "slider__item preview"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('li', {
      key: index,
      staticClass: "preview__item",
      class: {
        preview__item_curr: slide.curr
      },
      style: ({
        backgroundImage: ("url(" + (slide.thumb || slide.img) + ")"),
        width: (((100 / _vm.slides.length)) + "%")
      }),
      on: {
        "click": function($event) {
          return _vm.click(index)
        }
      }
    }, [_c('ext-link', {
      staticClass: "preview__link",
      class: {
        preview__link_hover: slide.curr && _vm.timer.interval
      },
      attrs: {
        "to": slide.to.path,
        "prevent-default": true
      }
    }, [_c('div', {
      staticClass: "preview__cover"
    }), _c('div', {
      staticClass: "preview__smoothly",
      class: {
        preview__smoothly_width: slide.curr && _vm.timer.interval
      },
      style: (slide.curr && _vm.timer.interval ? {
        transitionDuration: (_vm.interval + "s")
      } : {})
    }), _c('span', {
      staticClass: "preview__span",
      domProps: {
        "innerHTML": _vm._s(slide.title)
      }
    })])], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8949bf5c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/slider/homepage/Homepage.vue
// module id = e5341f404d649f820834
// module chunks = 16